import { ChevronRight } from "lucide-react";
import { Link } from "../router/Router";
import {
  categoryById,
  guidesByCategory,
  groupsForCategory,
} from "../content/registry";
import { CategoryIcon } from "../components/Icon";
import { Seo } from "../components/Seo";
import type { CategoryId, Guide } from "../content/types";

function GuideCard({ g }: { g: Guide }) {
  return (
    <Link to={g.route} className="hc-guide-card">
      <span className="hc-guide-card__title">
        {g.title}
        {g.status === "stub" ? (
          <span className="hc-chip hc-chip--soon">Soon</span>
        ) : null}
      </span>
      <span className="hc-guide-card__summary">{g.summary}</span>
      <span className="hc-guide-card__more">
        Read guide <ChevronRight size={14} aria-hidden="true" />
      </span>
    </Link>
  );
}

export function CategoryPage({ id }: { id: CategoryId }) {
  const cat = categoryById(id);
  if (!cat) return null;
  const guides = guidesByCategory(id);
  const groups = groupsForCategory(id);
  const ungrouped = guides.filter((g) => !g.group);

  return (
    <div className="hc-cat-page">
      <Seo title={cat.label} description={cat.description} path={`/${id}`} />

      <nav className="hc-crumb" aria-label="Breadcrumb">
        <Link to="/">Help</Link>
        <ChevronRight size={13} aria-hidden="true" />
        <span className="hc-crumb__current">{cat.label}</span>
      </nav>

      <header
        className="hc-cat-page__head"
        style={{ ["--accent" as string]: cat.accent }}
      >
        <span className="hc-cat-page__icon">
          <CategoryIcon name={cat.icon} size={26} />
        </span>
        <div>
          <h1>{cat.label}</h1>
          <p>{cat.description}</p>
        </div>
      </header>

      {groups.length === 0 ? (
        <div className="hc-guide-grid">
          {guides.map((g) => (
            <GuideCard key={g.route} g={g} />
          ))}
        </div>
      ) : (
        <>
          {ungrouped.length > 0 ? (
            <div className="hc-guide-grid">
              {ungrouped.map((g) => (
                <GuideCard key={g.route} g={g} />
              ))}
            </div>
          ) : null}
          {groups.map((grp) => (
            <section key={grp} className="hc-cat-group">
              <h2 className="hc-cat-group__label">{grp}</h2>
              <div className="hc-guide-grid">
                {guides
                  .filter((g) => g.group === grp)
                  .map((g) => (
                    <GuideCard key={g.route} g={g} />
                  ))}
              </div>
            </section>
          ))}
        </>
      )}
    </div>
  );
}
